/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React, { useState, useEffect } from 'react';
import { Nav, Tab } from 'react-bootstrap';
import SVG from 'react-inlinesvg';
import { toAbsoluteUrl } from '../../../_helpers';
import axios, { baseUrl } from '../../../../redux/my-axios';

const inittialRows = [
  {
    icon: '/media/svg/misc/006-plurk.svg',
    name: 'Armani Fragrance Free 3 Piece Gift',
    productCode: 'GFR-AR-UltaArma3',
    count: 17,
  },
  {
    icon: '/media/svg/misc/006-plurk.svg',
    name: 'Her trial size',
    productCode: 'GFR-BURB-Her',
    count: 14,
  },
  {
    icon: '/media/svg/misc/006-plurk.svg',
    name: 'Free 3 Piece Gift with $40 purchase',
    productCode: 'GFR-COA-3pcs',
    count: 11,
  },
  {
    icon: '/media/svg/misc/006-plurk.svg',
    name: 'Light Blue Pour Homme Eau de Toilette',
    productCode: 'GFR-DG-LBlueMen-45ML',
    count: 9,
  },
  {
    icon: '/media/svg/misc/006-plurk.svg',
    name: 'Armani Fragrance Free 3 Piece Gift',
    productCode: 'GFR-AR-UltaArma32',
    count: 9,
  },
  {
    icon: '/media/svg/misc/006-plurk.svg',
    name: 'Her trial size',
    productCode: 'GFR-BURB-Her2',
    count: 8,
  },
  {
    icon: '/media/svg/misc/006-plurk.svg',
    name: 'Free 3 Piece Gift with $40 purchase',
    productCode: 'GFR-COA-3pcs2',
    count: 6,
  },
  {
    icon: '/media/svg/misc/006-plurk.svg',
    name: 'Light Blue Pour Homme Eau de Toilette',
    productCode: 'GFR-DG-LBlueMen-45ML2',
    count: 6,
  },
  {
    icon: '/media/svg/misc/006-plurk.svg',
    name: 'Free 3 Piece Gift with $40 purchase',
    productCode: 'GFR-COA-3pcs3',
    count: 4,
  },
  {
    icon: '/media/svg/misc/006-plurk.svg',
    name: 'Light Blue Pour Homme Eau de Toilette',
    productCode: 'GFR-DG-LBlueMen-45ML3',
    count: 4,
  },
];

const URL = '/dashboard';
export function AdvanceTablesWidget2({
  className,
  chartColor = 'danger',
  baseColor = 'light-primary',
  title,
  target = 'MERCHANT',
  freq,
  freqFrom,
  type,
}) {
  const [rows, setRows] = useState(inittialRows);
  //const [key, setKey] = useState("M");
  useEffect(() => {
    //console.log('Freq: ' + freq);
    axios
      .post(
        URL,
        { target, type, freq, freqFrom },
        { headers: { action: 'gettable' } }
      )
      .then((response) => {
        //console.log('merchantBusinessCatList', response.data);
        switch (response.data.type) {
          case 'SUCCESS':
          case 'SUCCESS_WITH_WARNING':
          case 'SUCCESS_WITH_INFO':
            setRows(response.data.data);
            //console.log('businessCatList', businessCatList);
            // setErr({ err: null });
            break;
          default:
            // var errMsg = response.data.msg;
            // setErr({ err: errMsg.getDesc() });
            break;
        }
      })
      .catch((error) => {
        // setErr({ err: error });
      });
  }, []);

  const getPic = (productCode, pic) => {
    if (pic)
      return `${baseUrl}/product-image-download?id=${productCode}&file=${pic}`;
    else return toAbsoluteUrl('/media/logos/logo-gc.png');
  };
  return (
    <div className={`card card-custom bg-${baseColor} ${className}`}>
      {/* Head */}
      <div className='card-header border-0 pt-5'>
        <h3 className='card-title align-items-start flex-column'>
          <span className='card-label font-weight-bolder text-dark'>
            ТОП 10 БҮТЭЭГДЭХҮҮН
          </span>
          <span className='text-muted mt-3 font-weight-bold font-size-sm'>
            Сүүлийн 30 хоногт хамгийн олон борлуулагдсан
          </span>
        </h3>
      </div>
      {/* Body */}
      <div className='card-body pt-3 pb-0'>
        <div className='table-responsive'>
          <table className='table table-borderless table-vertical-center'>
            <thead>
              <tr>
                <th className='p-0' style={{ width: '50px' }} />
                <th className='p-0' style={{ minWidth: '220px' }} />
                <th className='p-0' style={{ minWidth: '30px' }} />
              </tr>
            </thead>
            <tbody>
              {rows.map((row) => (
                <tr key={row.productCode}>
                  <td className='pl-0 py-4'>
                    <div className='symbol symbol-50 symbol-light mr-1'>
                      <span className='symbol-label'>
                        <img
                          className='img-thumbnail'
                          style={{ width: '100%', height: '100%' }}
                          src={getPic(row.productCode, row.icon)}
                        ></img>
                      </span>
                    </div>
                  </td>
                  <td className='pl-0'>
                    <a
                      href={`/products/${row.productCode}/edit`}
                      className='text-dark-75 font-weight-bolder text-hover-primary mb-1 font-size-lg'
                    >
                      {row.name}
                    </a>
                    <div>
                      <span className='text-muted font-weight-bold'>
                        {row.productCode}
                      </span>
                    </div>
                  </td>
                  <td className='text-right'>
                    <span className='text-dark-75 font-weight-bolder d-block font-size-lg'>
                      {row.count}
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
